import { httpsCallable } from "@firebase/functions";
import { functions } from "./firebase";
export const createPaypalOrder = httpsCallable(functions, 'paypalCreateOrder')
export const handlePaypalOrder = httpsCallable(functions, 'paypalHandleOrder')

